import { OsUpdate } from '@era/osupdates-sdk';
import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AvailableOsUpdatesResolverActions = createActionGroup({
  source: 'Available Os Updates Resolver',
  events: {
    'Available os updates requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const OsUpdatesApiActions = createActionGroup({
  source: 'OsUpdates API',
  events: {
    'Available os updates loaded': props<{ availableOsUpdates: OsUpdate[] }>(),
    'Available os updates loaded error': props<{ error: ErrorModel }>(),
  },
});
